module.exports = __webpack_public_path__ + "assets/img/lp-report-2.c001a61c.svg";